import React from 'react';
import {
    Box,
    Button,
    Container,
    Link,
    Typography,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import ScrollToTopButton from "./ScrollToTopButton";

export default function SmsTerms() {
    return (
    <Box >
        <ScrollToTopButton />
        <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                bgcolor: '#223f73' }}>
            <Box
            component="img"
            src="/images/logo.png"
            alt="Logo"
            sx={{
                maxWidth: '160px',
                height: 'auto',
                display: 'block',
            }}
            />
            <Button component={NavLink} to='/' sx={{color: 'white', mr: 2}}>
                Home
            </Button>
        </Box>
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>
                SMS Terms of Use
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
            Effective Date: April 1, 2025
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
            Last Revised: April 19, 2025
            </Typography >
            
            <Box mt={4}>
            <Typography variant="h6">1. Program Description</Typography>
            <Typography paragraph>
            When you opt in, PR Innova Inc. (and its brands) may send SMS or MMS messages regarding:
            </Typography>            
            <Typography component="div" variant="body1">
            <Typography
                component="ul"
                sx={{
                m: 2,
                '& li::marker': {
                    fontWeight: 'bold',
                },
                }}
            >
                <li>Service alerts</li>
                <li>Account authentication (2FA)</li>
                <li>Marketing promotions (with explicit consent)</li>
                <li>Surveys or feedback requests</li>
            </Typography>

            </Typography>
                <Typography variant="h6">2. Opt-In Methods</Typography>
            <Typography paragraph>
            You may opt in by:
            </Typography>            
            <Typography component="div" variant="body1">
            <Typography
                component="ol"
                sx={{
                listStyleType: 'decimal',
                m: 2,
                '& li::marker': {
                    fontWeight: 'bold',
                },
                }}
            >
                <li>Checking a box on an online form and entering your mobile number;</li>
            </Typography>
            <Typography paragraph>
            By opting in, you confirm you are the account holder or have account holder permission.
            </Typography>             
            </Typography>

            <Typography variant="h6">3. Message Frequency</Typography>
            <Typography paragraph>
            Message frequency varies by interaction. Marketing programs typically send up to 4 msgs/month unless otherwise disclosed.
            </Typography>
    
            <Typography variant="h6">3. Opting Out</Typography>
            <Typography paragraph>
                To stop receiving SMS messages, text STOP to any message. You will receive one final 
                message confirming your opt-out. To get help, reply HELP or contact us at {' '}
                <Link href="mailto:support@prinnovainc.com">support@prinnovainc.com</Link>.
            </Typography>
    
            <Typography variant="h6">4. Charges</Typography>
            <Typography paragraph>
            Msg & data rates may apply. Charges are billed by your carrier and appear on your wireless invoice.
            </Typography>
    
            <Typography variant="h6">5. Opt-Out</Typography>
            <Typography paragraph>
            Text STOP, END, CANCEL, UNSUBSCRIBE, or QUIT to any message to opt out. You will receive a single confirmation text. No further messages will be sent unless you opt back in.
            </Typography>
    
            <Typography variant="h6">6. Help</Typography>
            <Typography paragraph>
            Text HELP for help or email <Link href='mailto:support@prinnovainc.com'>support@prinnovainc.com</Link>. Carrier-related issues should be directed to your wireless provider.
            </Typography>

            <Typography variant="h6">7. Supported Carriers</Typography>
            <Typography paragraph>
            Major U.S. and Puerto Rico carriers including AT&T, T-Mobile, Claro, Liberty, and others. Carriers are not liable for delayed or undelivered messages.
            </Typography>

            <Typography variant="h6">8. Privacy</Typography>
            <Typography paragraph>
            Mobile numbers are processed in accordance with our {' '}<Link component={NavLink} to='/privacy'>Privacy Policy</Link>. We do not share, rent, or sell your number.
            </Typography>

            <Typography variant="h6">9. User Obligations</Typography>
            <Typography paragraph>
            You agree to provide accurate mobile numbers, keep them up to date, and indemnify us for SMS sent to a number you no longer control if you fail to notify us of a change.
            </Typography>

            <Typography variant="h6">10. Disclaimers & Limitation of Liability</Typography>
            <Typography paragraph>
            SMS delivery may be impacted by network issues beyond our control. Our liability is limited as stated in the <Link to='/terms' component={NavLink}>Terms of Use</Link>.
            </Typography>        

            <Typography variant="h6">11. Indemnification</Typography>
            <Typography paragraph>
            You will indemnify and hold harmless PR Innova Inc. for claims arising from your violation of these SMS Terms or misuse of the program.
            </Typography>   

            <Typography variant="h6">12. Program Changes / Termination</Typography>
            <Typography paragraph>
            We may change or terminate any SMS program or these Terms at any time by providing notice (SMS or otherwise). Continued participation constitutes acceptance.
            </Typography>   

            <Typography variant="h6">13. Contact Us</Typography>
            <Typography paragraph>
                If you have any questions about these SMS Terms, please contact us at:
                <br /><br />
                <strong>PR Innova Inc</strong>
                <br />
                127 Calle Guadalquivir
                <br />
                San Juan PR 00927
                <br />
                <Link href="mailto:support@prinnovainc.com">support@prinnovainc.com</Link>
                <br />
            </Typography>
            </Box>
        </Container>
    </Box>
    )
}
